/**
 * Fires off all Smart Canvas OS lazy chunks in parallel so that route
 * transitions inside the OS are instant after the first authenticated mount.
 *
 * Vite/Rollup deduplicates dynamic imports by module URL, so calling these
 * here and again inside `React.lazy(() => import(...))` resolves from the
 * same in-flight (or cached) promise — no double fetch, no Suspense fallback
 * on the second hit.
 */
let started = false;

export function preloadOS(): void {
  if (started) return;
  started = true;

  // Schedule after the current paint so we don't fight the initial dashboard
  // render for bandwidth on slow connections.
  const kick = () => {
    void Promise.allSettled([
      // Shared
      import("@/pages/os/Account"),
      import("@/pages/os/OSRedirect"),
      import("@/pages/os/EnvSelect"),
      // Admin Hub
      import("@/pages/os/admin/AdminDashboard"),
      import("@/pages/os/admin/Clients"),
      import("@/pages/os/admin/Projects"),
      import("@/pages/os/admin/Quotes"),
      import("@/pages/os/admin/QuoteDetail"),
      import("@/pages/os/admin/QuoteWizardPage"),
      import("@/pages/os/admin/Invoices"),
      import("@/pages/os/admin/Users"),
      import("@/pages/os/admin/Team"),
      import("@/pages/os/admin/Studio"),
      import("@/pages/os/admin/Resources"),
      import("@/pages/os/admin/Settings"),
      // Operator Hub
      import("@/pages/os/operator/OperatorDashboard"),
      import("@/pages/os/operator/OperatorProjects"),
      import("@/pages/os/operator/WorkStudio"),
      // Client Hub
      import("@/pages/os/client/ClientDashboard"),
      import("@/pages/os/client/ClientProjects"),
      import("@/pages/os/client/ClientInvoices"),
      import("@/pages/os/client/ClientProjectDetail"),
      import("@/pages/os/client/ClientQuotes"),
    ]);
  };

  if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    (window as any).requestIdleCallback(kick, { timeout: 1500 });
  } else {
    setTimeout(kick, 0);
  }
}